import { Card, Typography } from "antd";
import { formatMinutes } from "../utils";

interface BreakdownItem {
  key: string;
  color: string;
  minutes: number;
  totalEntries: number;
}

interface BreakdownTableProps {
  items: BreakdownItem[];
}

const BreakdownTable = ({ items }: BreakdownTableProps) => (
  <Card style={{ flex: 1 }} bodyStyle={{ padding: 0 }}>
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr style={{ borderBottom: "1px solid #f0f0f0" }}>
          <th
            style={{
              padding: "10px 16px",
              textAlign: "left",
              fontSize: 12,
              color: "#8c8c8c",
              fontWeight: 600,
            }}
          >
            TITLE
          </th>
          <th
            style={{
              padding: "10px 16px",
              textAlign: "right",
              fontSize: 12,
              color: "#8c8c8c",
              fontWeight: 600,
            }}
          >
            DURATION
          </th>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <tr key={item.key} style={{ borderBottom: "1px solid #f0f0f0" }}>
            <td
              style={{
                padding: "10px 16px",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <div
                style={{
                  minWidth: 22,
                  height: 22,
                  borderRadius: 4,
                  backgroundColor: "#137AE9",
                  color: "white",
                  fontSize: 11,
                  fontWeight: 700,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  padding: "0 5px",
                }}
              >
                {item.totalEntries}
              </div>
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: item.color,
                  flexShrink: 0,
                  display: "inline-block",
                }}
              />
              <Typography.Text>{item.key}</Typography.Text>
            </td>
            <td
              style={{
                padding: "10px 16px",
                textAlign: "right",
                fontVariantNumeric: "tabular-nums",
              }}
            >
              {formatMinutes(item.minutes)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </Card>
);

export default BreakdownTable;
